import { AxiosStatic } from "axios";
import { QuestionConfig, CustomQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig/models";

export class QuestionnaireConfigApi {
    private axios: AxiosStatic;

    constructor(axios: AxiosStatic) {
        this.axios = axios;
    }

    public async get(questionnaireType: string) {
        const response = await this.axios.get<{ questions: QuestionConfig[]; additionalQuestions: CustomQuestionConfig[] }>(
            `/api/questionnaireconfig/${questionnaireType}`
        );
        return response.data;
    }
}
